const hasValue = value => value !== null && value !== undefined && value !== "";
const toId = value => (hasValue(value) ? String(value) : null);
const optionId = value => (value && typeof value === "object" ? value.id : value);

export const getEmployeeId = employee => employee?.employeeId ?? employee?.id ?? null;
export const getErrorMessage = error => error?.response?.data?.message || error?.message || "Employee request failed.";
export const createFailedEmployee = (employee, error) => ({
  ...employee,
  errors: { ...(employee?.errors || {}), nameOrNum: getErrorMessage(error) },
});
export const isSameId = (left, right) => toId(left) !== null && toId(left) === toId(right);
export const hasEmployeeErrors = employee => Object.keys(employee?.errors || {}).length > 0;

export function isSameEmployee(left, right) {
  if (!left || !right) return false;
  const employeeId = typeof right === "object" ? right.employeeId : right;
  const tableId = typeof right === "object" ? right.id : right;
  return isSameId(left.employeeId, employeeId) || isSameId(left.id, tableId) || isSameId(left.employeeId, tableId) || isSameId(left.id, employeeId);
}

export function ensureEmployeeTableId(employee, existing = null) {
  if (!employee) return employee;
  const employeeId = employee.employeeId ?? existing?.employeeId;
  const id = employee.id ?? existing?.id ?? employeeId;
  return { ...existing, ...employee, ...(hasValue(employeeId) ? { employeeId } : {}), ...(hasValue(id) ? { id: String(id) } : {}) };
}

export function upsertEmployeeInList(employees = [], savedEmployee) {
  const index = employees.findIndex(employee => isSameEmployee(employee, savedEmployee));
  const normalized = ensureEmployeeTableId(savedEmployee, index >= 0 ? employees[index] : null);
  if (!hasValue(normalized?.employeeId) && !hasValue(normalized?.id)) throw new Error("A persisted employee must have an identity.");
  return index < 0 ? [normalized, ...employees] : employees.map((employee, current) => current === index ? normalized : employee);
}

export const formatInvalidEmployees = (employees = [], translate) => employees.map(({ nameOrNum, errors = {} }) => ({
  content: nameOrNum || "Employee",
  children: Object.entries(errors).filter(([, message]) => message).map(([field, message]) => ({
    content: field === "nameOrNum" ? String(message) : `${translate(`benchmarking.survey.employee.entry-form.${field}`)}: ${message}`,
  })),
}));

export function prepareEmployeesForTable(employees = [], options = {}) {
  const functions = options.allEmployeeFunctions || [];
  return employees.map(employee => ({
    ...employee,
    specXFunc: functions.find(option => isSameId(option.id, optionId(employee.specXFunc))) ?? employee.specXFunc,
    showAllSpecXFunc: employee.showAllSpecXFunc ?? false,
  }));
}
